/** Limits and formats shared by the API and both web clients. */

/** German postal code — exactly five digits. */
export const POSTAL_CODE_PATTERN = /^\d{5}$/;

/**
 * Partner registration number, format A-BBBB-CCCCC-DD. The legacy login form
 * enforced this client-side only (`pattern="^\w{1}-\w{4}-\w{5}-\w{2}$"`), so the
 * server accepted anything.
 */
export const REGISTRATION_NUMBER_PATTERN = /^[A-Z0-9]-[A-Z0-9]{4}-[A-Z0-9]{5}-[A-Z0-9]{2}$/;

/** Herstellerschlüsselnummer — 4 digits identifying the manufacturer. */
export const HSN_PATTERN = /^\d{4}$/;

/** Typschlüsselnummer — 3 alphanumerics identifying the model variant. */
export const TSN_PATTERN = /^[A-Z0-9]{3}$/;

/** E.164, which is what the app should send after normalising a German number. */
export const PHONE_E164_PATTERN = /^\+[1-9]\d{7,14}$/;

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_FILES_PER_REQUEST = 8;

export const ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'] as const;
export const ALLOWED_DOCUMENT_MIME_TYPES = ['application/pdf'] as const;
export const ALLOWED_UPLOAD_MIME_TYPES = [
  ...ALLOWED_IMAGE_MIME_TYPES,
  ...ALLOWED_DOCUMENT_MIME_TYPES,
] as const;

/** Default radius a lead is offered to partners within. Legacy hardcoded 5. */
export const DEFAULT_MATCH_RADIUS_KM = 5;
export const MAX_MATCH_RADIUS_KM = 100;

export const REVIEW_MIN_STARS = 1;
export const REVIEW_MAX_STARS = 5;

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

/** Offers are stored in cents; refuse anything outside a plausible premium. */
export const MIN_OFFER_AMOUNT_CENTS = 1;
export const MAX_OFFER_AMOUNT_CENTS = 100_000_00;

/**
 * Portal access code — the shared gate in front of the partner login.
 * Four to eight digits; the value itself lives in the environment.
 */
export const ACCESS_CODE_PATTERN = /^\d{4,8}$/;
export const ACCESS_CODE_LENGTH = 4;
